import { render } from "./render_main_sections.html?vue&type=template&id=728c45ba&scoped=true&external"
import script from "./render_main_sections.js?vue&type=script&lang=js&external"
export * from "./render_main_sections.js?vue&type=script&lang=js&external"

import "./RenderMainSections.vue?vue&type=style&index=0&id=728c45ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728c45ba"]])

export default __exports__